import { Helper } from '../Common/Helpers/helper';
import { Component, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SpaContext } from '../Classes/spacontext';
import { UnitService } from '../Services/api/v2/Units/units.service';
import { LicenceHolderService } from '@services/licence_holder.service';
import { sharedResolution } from '../../../src/shared_resolution';

@Component({
	standalone: false,
	selector: 'licenceholder-footer',
	templateUrl: '../ViewHtml/Footer.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['../Css/Components/licenceHolderFooter.scss'],
})
export class LicenceHolderFooterComponent {
	inverted: boolean = false;
	instance: string = µ.Env.ActiveDomain;
	isIos: boolean;
	aboutText: string = null;
	showFulLAboutText = false;
	public readonly licenceHolderService = sharedResolution.resolve(LicenceHolderService);

	constructor(
		public _spaContext: SpaContext,
		private _router: Router,
		private _helper: Helper,
		private unitsService: UnitService,
	) {
		this.isIos = this._helper.is.ios();
		this.inverted = _spaContext.unitConfig.Theme !== null && _spaContext.unitConfig.Theme.VisibaLogoStyle === 1;
	}

	ngOnInit() {
		this.unitsService.getText(['Web_About']).subscribe((response) => {
			this.aboutText = response.data.Web_About;
		});
	}

	addHyphensToEmail(email: string): string {
		if (email === null || typeof email === 'undefined') return null;

		return email.replace('@', '\u200B@');
	}

	removeUrlStart(url: string) {
		if (url === null || typeof url === 'undefined') return null;

		return url.replace('https://', '').replace('http://', '');
	}
}
